export default __webpack_public_path__ + "static/media/website.7b12cf65.svg";